import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { CopyToClipboard } from '@openx/components-core/lib/CopyToClipboard/CopyToClipboard.tsx';
import { useTranslation } from 'react-i18next';

type ModalContentProps = {
  apiKey: string;
};

export const CreateApiKeyConfirmationModalContent = ({ apiKey }: ModalContentProps) => {
  const { t } = useTranslation();

  return (
    <DialogContent dividers>
      <Alert severity="warning" data-test="create-api-key-confirmation-alert" sx={{ whiteSpace: 'pre-line' }}>
        {t(
          "Make sure to copy your API Key now. You won't be able to see it again! \n Your generated key will expire in 90 days."
        )}
      </Alert>
      <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
        {t('API Key')}
      </Typography>
      <Box style={{ display: 'flex' }}>
        <Typography variant="body1Bold" data-test="api-key-value" sx={{ flexGrow: 0 }}>
          {apiKey}
        </Typography>
        <CopyToClipboard text={apiKey} iconSize="medium" />
      </Box>
    </DialogContent>
  );
};
